import {
  FETCH_BETA_REQUEST,
  FETCH_BETA_SUCCESS,
  FETCH_BETA_FAILURE,
  UPLOAD_BETA_EMAIL_REQUEST,
  UPLOAD_BETA_EMAIL_SUCCESS,
  UPLOAD_BETA_EMAIL_FAILURE,
  SEARCH_BETA_EMAIL_REQUEST_REQUEST,
  SEARCH_BETA_EMAIL_REQUEST_SUCCESS,
  SEARCH_BETA_EMAIL_REQUEST_FAILURE
} from './betaEmailAction'

const initialState = {
  loading: false,
  betaEmailData: [],
  searchResults: [],
  error: '',
};

const betaEmailReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_BETA_REQUEST:
    case UPLOAD_BETA_EMAIL_REQUEST:
      return {
        ...state,
        loading: false,
      };
    case FETCH_BETA_SUCCESS:
      return {
        loading: false,
        betaEmailData: [...state.betaEmailData, ...action.payload],
        error: '',
      };
    case FETCH_BETA_FAILURE:
      return {
        loading: false,
        betaEmailData: [],
        error: action.payload,
      };
    case UPLOAD_BETA_EMAIL_SUCCESS:
      return {
        ...state,
        loading: false,
        betaEmailData: [...state.betaEmailData, action.payload.email],
        error: '',
      };
    case UPLOAD_BETA_EMAIL_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case SEARCH_BETA_EMAIL_REQUEST_REQUEST:
      return {
        ...state,
        loading: false,
      };
    case SEARCH_BETA_EMAIL_REQUEST_SUCCESS:
      return {
        ...state,
        loading: false,
        searchResults: action.payload,
        error: '',
      };
    case SEARCH_BETA_EMAIL_REQUEST_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};

export default betaEmailReducer;
